module.exports = __webpack_public_path__ + "9f77b3e93f9d0ca64c59284749ba3f24.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/middle.png
// module id = 682
// module chunks = 0